import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Link, useLocation } from "react-router-dom";
import { CRoutePaths } from "../../../../constants/CApp";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux-store/store";

interface ISidebarMenu {
  icon: React.ReactNode;
  alt: string;
  path: string; // Add path to manage routing
  visibility: boolean;
}

const InitSidebarMenu: ISidebarMenu[] = [
  {
    icon: <HomeIcon sx={{ width: "25px" }} />,
    alt: "home",
    path: CRoutePaths.Applications,
    visibility: true,
  },
  {
    icon: <NotificationsActiveIcon sx={{ width: "25px" }} />,
    alt: "Notifications",
    path: CRoutePaths.Notifications,
    visibility: true,
  },
  {
    icon: <PersonIcon sx={{ width: "25px" }} />,
    alt: "User Control",
    path: CRoutePaths.UserControl,
    visibility: true,
  },
];

const Sidebar: React.FC = () => {
  const location = useLocation();
  const { user, features } = useSelector((state: RootState) => state.user);
  const [activeIndex, setActiveIndex] = useState(0);
  const [sidebarMenu, setSideMenus] = useState<ISidebarMenu[]>(
    Object.assign([], InitSidebarMenu)
  );

  useEffect(() => {
    setActiveIndex(getActiveIndex());
  }, []);

  useEffect(() => {
    setActiveIndex(getActiveIndex());
  }, [location.pathname]);

  const getActiveIndex = () => {
    let activeItem: number = InitSidebarMenu.findIndex(
      (item) => item.path === location.pathname
    );
    return activeItem !== -1 ? activeItem : 0;
  };

  useEffect(() => {
    let userCtlTabVis = features.userControl.viewUserControl;
    let lSideMenus: ISidebarMenu[] = Object.assign([], InitSidebarMenu);

    //User Control view
    var userCtlMenu = lSideMenus.find((x) => x.path == CRoutePaths.UserControl);
    if (userCtlMenu != undefined) {
      userCtlMenu.visibility = userCtlTabVis;
    }

    //Notification view
    var notifyMenu = lSideMenus.find(
      (x) => x.path == CRoutePaths.Notifications
    );
    if (notifyMenu != undefined) {
      notifyMenu.visibility = features.notification.accessNotificationBoard;
    }

    setSideMenus(lSideMenus);
  }, [features.userControl.viewUserControl]);

  const handleActive = (index: number) => () => {
    setActiveIndex(index);
  };

  return (
    <div className="sidebar-container">
      <div className="icon-container">
        {sidebarMenu.map((menu, index) => {
          if (menu.visibility) {
            return (
              <Link
                to={menu.path}
                key={index}
                onClick={handleActive(index)}
                style={{ color: "black" }}
              >
                <div
                  className={`icons-container ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  {menu.icon}
                </div>
              </Link>
            );
          }

          return <></>;
        })}
      </div>
    </div>
  );
};

export default Sidebar;
